// ImagesHistoryAccordion.tsx
import { FC, useState } from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import DownloadIcon from "@mui/icons-material/Download";

interface HistoryItem {
  date: string;
  amount: number;
  url: string;
}

interface Props {
  history: Record<string, any>;
}

const ImagesHistoryAccordion: FC<Props> = ({ history }) => {
  // Extraemos sólo los items que tenga URL
  // const images: HistoryItem[] = Object.entries(history)
  //   .map(([date, item]) => ({
  //     date,
  //     amount: item.details?.amountEntered ?? 0,
  //     url: item.details?.lotClosingTPV ?? "",
  //   }))
  //   .filter((img) => img.url);

  const images: HistoryItem[] = [];


  Object.entries(history).forEach(([date, item]) => {
    const amount = item.details?.amountEntered ?? 0;
    const raw = item.details?.lotClosingTPV ?? "";
    if (!raw) return;

    // Extrae todas las URLs HTTP/HTTPS del string
    const urlList = raw.match(/https?:\/\/.*?(?=https?:\/\/|$)/g) || [];

    urlList.forEach((url: any, idx: any) => {
      images.push({
        // Si vienen varias, las numeramos: "2025-06-10 (1)", "2025-06-10 (2)", …
        date: urlList.length > 1 ? `${date} (${idx + 1})` : date,
        amount,
        url,
      });
    });
  });

  // Estado para controlar el diálogo
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState<HistoryItem | null>(null);

  const handleClick = (img: HistoryItem) => {
    setSelected(img);
    setOpen(true);
  };
  const handleClose = () => setOpen(false);

  return (
    <>
      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography variant="body2" fontWeight="bold">
            Historial de Imágenes
          </Typography>
        </AccordionSummary>

        <AccordionDetails>
          <Box
            sx={{
              display: "flex",
              overflowX: "auto",
              gap: 2,
              py: 1,
            }}
          >
            {images.map((img) => (
              <Box
                key={img.date}
                onClick={() => handleClick(img)}
                sx={{
                  flex: "0 0 auto",
                  width: { xs: "100%", sm: 200 },
                  height: { xs: 200, sm: 150 },
                  position: "relative",
                  borderRadius: 1,
                  overflow: "hidden",
                  boxShadow: 1,
                  cursor: "pointer",
                }}
              >
                <img
                  src={img.url}
                  alt={img.date}
                  loading="lazy"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                  }}
                />
                <Box
                  component="span"
                  sx={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    p: 0.5,
                    bgcolor: "rgba(0,0,0,0.6)",
                  }}
                >
                  <Typography
                    variant="caption"
                    sx={{ color: "#fff", fontWeight: "bold" }}
                  >
                    {img.date}: ${img.amount}
                  </Typography>
                </Box>
              </Box>
            ))}
          </Box>
        </AccordionDetails>
      </Accordion>

      {/* Diálogo para imagen grande */}
      <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
        <DialogTitle>
          {selected?.date}: ${selected?.amount}
        </DialogTitle>
        <DialogContent>
          {selected && (
            <Box
              component="img"
              src={selected.url}
              alt={selected.date}
              sx={{ width: "100%", height: "auto", borderRadius: 1 }}
            />
          )}
        </DialogContent>
        <DialogActions>
          {selected && (
            <Button
              startIcon={<DownloadIcon />}
              component="a"
              href={selected.url}
              download={`image_${selected.date.replace(/[: ]/g, "_")}.jpg`}
            >
              Descargar
            </Button>
          )}
          <Button onClick={handleClose}>Cerrar</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ImagesHistoryAccordion;
